import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { DataService } from '../services/data.service';
import { SettingService } from '../services/setting.service';
import { StorageService } from '../services/storage.service';
import { StoredItem } from '../shared/enums';

// First visit to a multi-language venue: have the guest pick a language before anything
// else, then send them on to the exact URL they entered with (deep links included).
// Only guards the routes a guest can land on from a QR code or shared link - never
// mid-flow pages like payment returns or order confirmation.
//
// Like menuHomeGuard, this can run before the boot chain has loaded the config, so it
// waits for the restaurant (set right after the config, whose languages it needs).
export const languageSelectionGuard: CanActivateFn = (_route, state) => {
  const dataService = inject(DataService);
  const settingService = inject(SettingService);
  const storageService = inject(StorageService);
  const router = inject(Router);

  return toObservable(dataService.restaurant).pipe(
    filter(restaurant => restaurant !== null),
    take(1),
    map(() => {
      const needsSelection = settingService.hasMultiLanguage() && !storageService.get(StoredItem.Language);
      return needsSelection
        ? router.createUrlTree(['/select-language'], { queryParams: { returnUrl: state.url } })
        : true;
    }),
  );
};
